<script  lang="ts" setup="">
import {ref} from "vue";
import MdmService from "@/services/MdmService";
import {useRouter} from "vue-router";
import {store} from "@/store";
import {RouteNames} from "@/router/routeNames";

const router = useRouter()

const username = ref('') // MDM Owner ID
const password = ref('') // MDM Owner password
const apiKey = ref('') // MDM Electron key
const channelId = ref('') // Optional YouTube channel ID (needs to be available in MDM Owner's group)

async function login() {
  const data = await MdmService.login(username.value, password.value, apiKey.value)

  store.setDetails({
    token: data.accessToken,
    country: 'uk',
    app_id: 'youtube',
  })

  if (!channelId.value.trim()) {
    await router.push({name: RouteNames.Channels})
    return
  }
  await router.push({name: RouteNames.Channel, params: {channelId: channelId.value.trim()}})
}
</script>

<template>
  <div>
    <label>Username</label>
    <input type="text" v-model="username">
    <label>Password</label>
    <input type="text" v-model="password">
    <label for="">API Key</label>
    <input type="text" v-model="apiKey">
    <label for="">ChannelId</label>
    <input type="text" v-model="channelId">
    <button @click="login">Login</button>
  </div>
</template>

<style lang="scss">
</style>
